/**
* Nom : trialList.js
* Description : Ce fichier contient la définition de la page trialList 
*               Cette page liste les essais
* Date de création : 27 septembre 2024
*/

/* CSS et assets */
// None

/* Bibliothèques et composants */
import { TabRD } from 'package_ui_ihm/dist'
import { Container } from 'package_ui_ihm/dist'
import { AddItem } from 'package_ui_ihm/dist'
import { ListFilter } from 'package_ui_ihm/dist'
import { TextFilter } from 'package_ui_ihm/dist'
import { ItemLink } from 'package_ui_ihm/dist'
import { IconStatus } from 'package_ui_ihm/dist'
import Divider from '@mui/material/Divider';

/* Hook */
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom'
import { useAuth } from 'package_ui_ihm/dist'
import { useApi } from 'package_ui_ihm/dist'
import { useData } from 'package_ui_ihm/dist';
import { useFilter } from 'package_ui_ihm/dist'
import { useScreenWidth } from 'package_ui_ihm/dist'


/**
* TrialList : affiche la page qui liste les essais
*             filtrage de la liste possible selon la catégorie, la variété et le type de cible, 
*                  le type de traitement, un article scientifique, un rapport interne et l'année
*             un lien permet d'afficher une page avec un formulaire pour créer un nouvel essai
*             un click sur l'essai permet d'afficher sa page avec ses informations détaillées
*             Un selecteur permet de basculer l'affichage liste en tableau avec les paramètres des modalités des essais
*
* Type : page 
*
* Parametres : 
*  None
*/
function TrialList() {

  //Define useParam
  const { catId, varId, typeId } = useParams()


  // Define useState hooks
  const [selectedTreatmentType, setSelectedTreatmentType] = useState(0);
  const [selectedCat, setSelectedCat] = useState(0);
  const [selectedVar, setSelectedVar] = useState(0);
  const [selectedTargetType, setSelectedTargetType] = useState(0);
  const [selectedArticle, setSelectedArticle] = useState(0);
  const [selectedReport, setSelectedReport] = useState(0);
  const [selectedYear, setSelectedYear] = useState(0);
  const [selectedKeyword, setSelectedKeyword] = useState("");
  const [selectedValidationStatus, setSelectedValidationStatus] = useState(0);
  const [prevCat, setPrevCat] = useState(0);
  const [treatmentTypes, setTreatmentTypes] = useState([])
  const [categories, setCategories] = useState([])
  const [varieties, setVarieties] = useState([])
  const [articles, setArticles] = useState([])
  const [reports, setReports] = useState([])
  const [trials, setTrials] = useState([])
  const [years, setYears] = useState([]);
  const [filteredVarieties, setFilteredVarieties] = useState(varieties);
  const [filteredIdTrials, setFilteredIdTrials] = useState([]);
  const [filteredTempTrials, setFilteredTempTrials] = useState([]);
  const [filteredTrials, setFilteredTrials] = useState([]);
  const [statusTreatmentType, setStatusTreatmentType] = useState(null)
  const [statusCategory, setStatusCategory] = useState(null)
  const [statusVariety, setStatusVariety] = useState(null)
  const [statusTrial, setStatusTrial] = useState(null)
  const [isDataLoading, setDataLoading] = useState(false)


  // Define useContext hooks
  const { authStatus, authToken } = useAuth();
  const { path } = useApi();
  const { treatmentFilter, setTreatmentFilter } = useFilter();
  const { validationStatus, targetTypes } = useData();


  // Define useScreenWidth hooks
  const screenWidth = useScreenWidth();


  // Define functions
  function retrieve_param_object_from_id(list, id) {
    return (list.find((item) => (item['id'] === Number(id))))['value']
  }

  function updateFilteredTrials() {
    // Filter treatment type
    if( Number(selectedTreatmentType) > 0 
        && Number(selectedCat) === 0 
        && Number(selectedVar) === 0 
        && Number(selectedTargetType) === 0
        && Number(selectedYear) === 0)
    {
      setFilteredTempTrials(filteredIdTrials.filter(trial => trial.treatment_type_id === Number(selectedTreatmentType)))
    } 
    // Filter category
    else if( Number(selectedTreatmentType) === 0 
              && Number(selectedCat) > 0 
              && Number(selectedVar) === 0 
              && Number(selectedTargetType) === 0
              && Number(selectedYear) === 0)
    {
      setFilteredTempTrials(filteredIdTrials.filter(trial => trial.target.category_id === Number(selectedCat)))
    } 
    // Filter target type
    else if( Number(selectedTreatmentType) === 0 
              && Number(selectedCat) === 0 
              && Number(selectedVar) === 0 
              && Number(selectedTargetType) > 0
              && Number(selectedYear) === 0)
    {
      setFilteredTempTrials(filteredIdTrials.filter(trial => trial.target.target_type_id === Number(selectedTargetType)))
    }  
    // Filter year
    else if( Number(selectedTreatmentType) === 0 
              && Number(selectedCat) === 0 
              && Number(selectedVar) === 0 
              && Number(selectedTargetType) === 0
              && Number(selectedYear) > 0)
    {
      setFilteredTempTrials(filteredIdTrials.filter(trial => trial.year === retrieve_param_object_from_id(years, selectedYear)))
    }  
    // Filter treatment type and category
    else if( Number(selectedTreatmentType) > 0 
              && Number(selectedCat) > 0 
              && Number(selectedVar) === 0 
              && Number(selectedTargetType) === 0
              && Number(selectedYear) === 0)
    {
      setFilteredTempTrials(filteredIdTrials.filter(trial => trial.treatment_type_id === Number(selectedTreatmentType) 
                                                            && trial.target.category_id === Number(selectedCat)))
    } 
    // Filter treatment type and target type
    else if( Number(selectedTreatmentType) > 0 
              && Number(selectedCat) === 0 
              && Number(selectedVar) === 0 
              && Number(selectedTargetType) > 0
              && Number(selectedYear) === 0)
    {
      setFilteredTempTrials(filteredIdTrials.filter(trial => trial.treatment_type_id === Number(selectedTreatmentType) 
                                                            && trial.target.target_type_id === Number(selectedTargetType)))
    }  
    // Filter treatment type and year
    else if( Number(selectedTreatmentType) > 0 
              && Number(selectedCat) === 0 
              && Number(selectedVar) === 0 
              && Number(selectedTargetType) === 0
              && Number(selectedYear) > 0)
    {
      setFilteredTempTrials(filteredIdTrials.filter(trial => trial.treatment_type_id === Number(selectedTreatmentType) 
                                                          && trial.year === retrieve_param_object_from_id(years, selectedYear)))
    } 
    // Filter category and variety
    else if( Number(selectedTreatmentType) === 0 
              && Number(selectedCat) > 0 
              && Number(selectedVar) > 0 
              && Number(selectedTargetType) === 0
              && Number(selectedYear) === 0)
    {
      setFilteredTempTrials(filteredIdTrials.filter(trial => trial.target.category_id === Number(selectedCat) 
                                                            && trial.target.variety_id === Number(selectedVar)))
    }
    // Filter category and target type
    else if( Number(selectedTreatmentType) === 0 
              && Number(selectedCat) > 0 
              && Number(selectedVar) === 0 
              && Number(selectedTargetType) > 0
              && Number(selectedYear) === 0)
    {
      setFilteredTempTrials(filteredIdTrials.filter(trial => trial.target.category_id === Number(selectedCat) 
                                                            && trial.target.target_type_id === Number(selectedTargetType)))
    } 
    // Filter category and year
    else if( Number(selectedTreatmentType) === 0 
              && Number(selectedCat) > 0 
              && Number(selectedVar) === 0 
              && Number(selectedTargetType) === 0
              && Number(selectedYear) > 0)
    {
      setFilteredTempTrials(filteredIdTrials.filter(trial => trial.target.category_id === Number(selectedCat) 
                                                            && trial.year === retrieve_param_object_from_id(years, selectedYear)))
    } 
    // Filter target type and year
    else if( Number(selectedTreatmentType) === 0 
              && Number(selectedCat) === 0 
              && Number(selectedVar) === 0 
              && Number(selectedTargetType) > 0
              && Number(selectedYear) > 0)
    {
      setFilteredTempTrials(filteredIdTrials.filter(trial => trial.target.target_type_id === Number(selectedTargetType) 
                                                            && trial.year === retrieve_param_object_from_id(years, selectedYear)))
    } 
    // Filter treatment type and category and variety 
    else if( Number(selectedTreatmentType) > 0 
              && Number(selectedCat) > 0 
              && Number(selectedVar) > 0 
              && Number(selectedTargetType) === 0
              && Number(selectedYear) === 0)
    {
      setFilteredTempTrials(filteredIdTrials.filter(trial => trial.treatment_type_id === Number(selectedTreatmentType) 
                                                            && trial.target.category_id === Number(selectedCat) 
                                                            && trial.target.variety_id === Number(selectedVar)))
    }  
    // Filter treatment type and category and target type 
    else if( Number(selectedTreatmentType) > 0 
              && Number(selectedCat) > 0 
              && Number(selectedVar) === 0 
              && Number(selectedTargetType) > 0
              && Number(selectedYear) === 0)
    {
      setFilteredTempTrials(filteredIdTrials.filter(trial => trial.treatment_type_id === Number(selectedTreatmentType) 
                                                            && trial.target.category_id === Number(selectedCat) 
                                                            && trial.target.target_type_id === Number(selectedTargetType)))
    } 
    // Filter treatment type and category and year 
    else if( Number(selectedTreatmentType) > 0 
              && Number(selectedCat) > 0 
              && Number(selectedVar) === 0 
              && Number(selectedTargetType) === 0
              && Number(selectedYear) > 0)
    {
      setFilteredTempTrials(filteredIdTrials.filter(trial => trial.treatment_type_id === Number(selectedTreatmentType) 
                                                            && trial.target.category_id === Number(selectedCat) 
                                                            && trial.year === retrieve_param_object_from_id(years, selectedYear)))
    }
    // Filter treatment type and target type and year 
    else if( Number(selectedTreatmentType) > 0 
              && Number(selectedCat) === 0 
              && Number(selectedVar) === 0 
              && Number(selectedTargetType) > 0
              && Number(selectedYear) > 0)
    {
      setFilteredTempTrials(filteredIdTrials.filter(trial => trial.treatment_type_id === Number(selectedTreatmentType) 
                                                            && trial.target.target_type_id === Number(selectedTargetType) 
                                                            && trial.year === retrieve_param_object_from_id(years, selectedYear)))
    }   
    // Filter category and variety and target type 
    else if( Number(selectedTreatmentType) === 0 
              && Number(selectedCat) > 0 
              && Number(selectedVar) > 0 
              && Number(selectedTargetType) > 0
              && Number(selectedYear) === 0)
    {
      setFilteredTempTrials(filteredIdTrials.filter(trial => trial.target.category_id === Number(selectedCat) 
                                                            && trial.target.variety_id === Number(selectedVar) 
                                                            && trial.target.target_type_id === Number(selectedTargetType)))
    }  
    // Filter category and variety and year 
    else if( Number(selectedTreatmentType) === 0 
              && Number(selectedCat) > 0 
              && Number(selectedVar) > 0 
              && Number(selectedTargetType) === 0
              && Number(selectedYear) > 0)
    {
      setFilteredTempTrials(filteredIdTrials.filter(trial => trial.target.category_id === Number(selectedCat) 
                                                      && trial.target.variety_id === Number(selectedVar) 
                                                      && trial.year === retrieve_param_object_from_id(years, selectedYear)))
    } 
    // Filter treatment type and category and variety and target type 
    else if( Number(selectedTreatmentType) > 0 
              && Number(selectedCat) > 0 
              && Number(selectedVar) > 0 
              && Number(selectedTargetType) > 0
              && Number(selectedYear) === 0)
    {
      setFilteredTempTrials(filteredIdTrials.filter(trial => trial.treatment_type_id === Number(selectedTreatmentType) 
                                                            && trial.target.category_id === Number(selectedCat) 
                                                            && trial.target.variety_id === Number(selectedVar) 
                                                            && trial.target.target_type_id === Number(selectedTargetType)))
    } 
    // Filter treatment type and category and variety and year 
    else if( Number(selectedTreatmentType) > 0 
              && Number(selectedCat) > 0 
              && Number(selectedVar) > 0 
              && Number(selectedTargetType) === 0
              && Number(selectedYear) > 0)
    {
      setFilteredTempTrials(filteredIdTrials.filter(trial => trial.treatment_type_id === Number(selectedTreatmentType) 
                                                            && trial.target.category_id === Number(selectedCat) 
                                                            && trial.target.variety_id === Number(selectedVar) 
                                                            && trial.year === retrieve_param_object_from_id(years, selectedYear)))
    }  
    // Filter category and variety and target type and year 
    else if( Number(selectedTreatmentType) === 0 
              && Number(selectedCat) > 0 
              && Number(selectedVar) > 0 
              && Number(selectedTargetType) > 0
              && Number(selectedYear) > 0)
    {
      setFilteredTempTrials(filteredIdTrials.filter(trial => trial.target.category_id === Number(selectedCat) 
                                                            && trial.target.variety_id === Number(selectedVar) 
                                                            && trial.target.target_type_id === Number(selectedTargetType)
                                                            && trial.year === retrieve_param_object_from_id(years, selectedYear)))
    }  
    // Filter treatment type and category and variety and target type and year
    else if( Number(selectedTreatmentType) > 0 
              && Number(selectedCat) > 0 
              && Number(selectedVar) > 0 
              && Number(selectedTargetType) > 0
              && Number(selectedYear) > 0)
    {
      setFilteredTempTrials(filteredIdTrials.filter(trial => trial.treatment_type_id === Number(selectedTreatmentType) 
                                                            && trial.target.category_id === Number(selectedCat) 
                                                            && trial.target.variety_id === Number(selectedVar) 
                                                            && trial.target.target_type_id === Number(selectedTargetType)
                                                            && trial.year === retrieve_param_object_from_id(years, selectedYear)))
    } 
    // No filter
    else
    {
      setFilteredTempTrials(filteredIdTrials)
    }
  }

  function updateFilteredTrialsByKeywords() {
    // Filter keywords
    if(selectedKeyword !== ""
        && Number(selectedValidationStatus) === 0)
    {
      setFilteredTrials(filteredTempTrials.filter(trial => trial.keywords.toLowerCase().includes(selectedKeyword.toLowerCase())))
    } 
    // Filter validation statuts
    else if(selectedKeyword === ""
            && Number(selectedValidationStatus) > 0)
    {
      setFilteredTrials(filteredTempTrials.filter(trial => trial.validation_status.id === Number(selectedValidationStatus)))
    } 
    // Filter keywords and validation statuts
    else if(selectedKeyword !== ""
        && Number(selectedValidationStatus) > 0)
    {
      setFilteredTrials(filteredTempTrials.filter(trial => trial.keywords.toLowerCase().includes(selectedKeyword.toLowerCase()) 
                                                            && trial.validation_status.id === Number(selectedValidationStatus)))
    } 
    // No filter
    else
    {
      setFilteredTrials(filteredTempTrials)
    }
  }

  function updateFilteredVarieties() {
    // Check category change to reinit variety except at the first loading of page
    if(selectedCat !== prevCat)
    {
      setSelectedVar(0);
      setPrevCat(selectedCat);
    } 
    // Filtering of varieties
    if( selectedCat > 0 )
    {
      setFilteredVarieties(varieties.filter((variety) => variety.category_id === Number(selectedCat)))
    }  
    else
    {
      setFilteredVarieties(varieties)
    }
  }

  async function retrieveData() {
    // Token
    const token = "Bearer " + authToken
    // Headers
    const headers = {
      accept: 'application/json',
      Authorization: token,
    }
    // Requests in parallel to win time 
    const [resTreatmentType, resCategory, resVariety, resArticle, resReport, resTrial] = await Promise.all([
      // Treatment types
      fetch(path + "/api/bo-trty/", {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
        headers,
      }),
      // Categories
      fetch(path + "/api/bo-cary/", {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
        headers,
      }),
      // Varieties
      fetch(path + "/api/bo-vaty/", {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
        headers,
      }),
      // Scientific articles
      fetch(path + "/api/bo-scar/filter-list/", {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
        headers,
      }),
      // Internal reports
      fetch(path + "/api/bo-atre/", {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
        headers,
      }),
      // Trials
      fetch(path + "/api/bo-tral/trial-list/", {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
        headers,
      }),
    ])
    // Responses in parallel to win time
    const [dataTreatmentType, dataCategory, dataVariety, dataArticle, dataReport, dataTrial] = await Promise.all([
      resTreatmentType.json(),
      resCategory.json(),
      resVariety.json(),
      resArticle.json(),
      resReport.json(),
      resTrial.json(),
    ])
    // Set variables
    setStatusTreatmentType(resTreatmentType.ok)
    setTreatmentTypes(dataTreatmentType["results"].sort((a, b) => (a.name > b.name)?1:-1))
    setStatusCategory(resCategory.ok)
    setCategories(dataCategory["results"].sort((a, b) => (a.name > b.name)?1:-1))
    setStatusVariety(resVariety.ok)
    setVarieties(dataVariety["results"].sort((a, b) => (a.name > b.name)?1:-1))
    setArticles(dataArticle)
    setReports(dataReport["results"].sort((a, b) => (a.internal_reference > b.internal_reference)?1:-1))
    setStatusTrial(resTrial.ok)
    const treatment_list = dataTrial
    setTrials(treatment_list)
    // Year des trials 
    const year_list = [...new Set(treatment_list.map((treatment) => (treatment.year)))]
    const year_dict = year_list.map((year, index) => ({"id": index + 1, "value": year}))
    setYears(year_dict)
    // Dataloading
    setDataLoading(false)
  }

  async function retrieveTrials(article_id, report_id) {
    // Token
    const token = "Bearer " + authToken
    // Headers
    const headers = {
      accept: 'application/json',
      Authorization: token,
    }
    //List of trial_id linked to article_id
    var trialsByArticle  
    //List of trial_id linked to report_id
    var trialsByReport  
    // Requests in parallel to win time
    const [resArticle, resReport] = await Promise.all([
      // Retrieve trials linked to scientific_article
      fetch(path + "/api/bo-ltsa/?scientific_article_id=" + article_id, {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
        headers,
      }),
      // Retrieve trials linked to at_report
      fetch(path + "/api/bo-ltar/?at_report_id=" + report_id, {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
        headers,
      }),
    ])
    // Responses in parallel to win time
    const [dataArticle, dataReport] = await Promise.all([
      resArticle.json(),
      resReport.json(),
    ])
    // Set variables
    if(dataArticle !== undefined) {
      trialsByArticle = dataArticle["results"].map((item) => item["trial_id"])
    } else {
      trialsByArticle = []
    }
    if(dataReport !== undefined) {
      trialsByReport = dataReport["results"].map((item) => item["trial_id"])
    } else {
      trialsByReport = []
    }
    // List concatenation
    if(article_id > 0 && report_id > 0) {
      var treatmentIdList = []
      for(const item of trialsByArticle) {
        if(trialsByReport.includes(item)) {
          treatmentIdList.push(item)
        }
      }
      setFilteredIdTrials(trials.filter((treatment) => treatmentIdList.includes(treatment.id)))
    } else if(article_id > 0 && report_id < 1) {
      setFilteredIdTrials(trials.filter((treatment) => trialsByArticle.includes(treatment.id)))
    } else if(article_id < 1 && report_id > 0) {
      setFilteredIdTrials(trials.filter((treatment) => trialsByReport.includes(treatment.id)))
    } else {
      setFilteredIdTrials(trials)
    }
  }

  const filterReset = (event) => {
    event.preventDefault();
    setFilteredTrials(trials)
    setSelectedTreatmentType(0)
    setSelectedCat(0)
    setSelectedVar(0)
    setSelectedTargetType(0)
    setSelectedArticle(0)
    setSelectedReport(0)
    setSelectedYear(0)
    setSelectedKeyword("")
    setSelectedValidationStatus(0)
  }

  const saveFilters = (event) => {
    // Ne pas utiliser event.preventDefault(); ici car cela bloque la navigation vers la page targetDetails
    var filters = {
      treatment_type_id: selectedTreatmentType,
      category_id: selectedCat,
      variety_id: selectedVar,
      target_type_id: selectedTargetType,
      scientific_article: selectedArticle,
      at_report: selectedReport,
      year: selectedYear,
      keywords: selectedKeyword,
      validation_status: selectedValidationStatus
    }
    setTreatmentFilter(filters)
  }


  // Define useEffect hooks
  useEffect(() => {
    if(authStatus === 200)
    {
      setDataLoading(true)
      retrieveData()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if(catId !== undefined && varId !== undefined && typeId !== undefined){
      setSelectedCat(catId)
      setPrevCat(catId)
      setSelectedVar(varId)
      setSelectedTargetType(typeId)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [catId, varId, typeId])

  useEffect(() => {
    if(treatmentFilter !== null)
    {
      setSelectedTreatmentType(treatmentFilter['treatment_type_id'])
      setSelectedCat(treatmentFilter['category_id'])
      setPrevCat(treatmentFilter['category_id'])
      setSelectedVar(treatmentFilter['variety_id'])
      setSelectedTargetType(treatmentFilter['target_type_id'])
      setSelectedArticle(treatmentFilter['scientific_article']) 
      setSelectedReport(treatmentFilter['at_report'])
      setSelectedYear(treatmentFilter['year'])
      setSelectedKeyword(treatmentFilter['keywords'])
      setSelectedValidationStatus(treatmentFilter['validation_status']) 
      setTreatmentFilter(null)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [treatmentFilter])

  useEffect(() => {
    retrieveTrials(selectedArticle, selectedReport);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trials, selectedArticle, selectedReport])

  useEffect(() => {
    updateFilteredTrials();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredIdTrials, selectedTreatmentType, selectedCat, selectedVar, selectedTargetType, selectedYear])

  useEffect(() => {
    updateFilteredTrialsByKeywords();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredTempTrials, selectedKeyword, selectedValidationStatus])

  useEffect(() => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredTrials])

  useEffect(() => {
    updateFilteredVarieties();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varieties, selectedCat])


  // Render component
  return (
    <div>
      <TabRD tabNumber={2}/>
      <div className={(screenWidth > 650) ? 'App' : 'App-ss'}>
        <Container>
          {isDataLoading ? (
            <p>Chargement des données</p>
          ) : (
            (statusTreatmentType === true && statusCategory === true && statusVariety === true && statusTrial === true) ? (   
              <div className={(screenWidth > 650) ? 'grid-1-3' : null}>
              {/*Normal size of screen*/}
                {/*Filtering*/}
                <div className='flex-rows'>
                  <AddItem path='/trials/new'>Ajouter un essai</AddItem>
                  <h3>Filtres</h3>
                  <TextFilter label="Mot clé" value={selectedKeyword} setValue={setSelectedKeyword}></TextFilter>
                  <ListFilter labelText='Type de traitements' choices={treatmentTypes.sort((a, b) => (a.name > b.name)?1:-1)} choiceParam={'name'} selectedItem={selectedTreatmentType} setSelectedItem={setSelectedTreatmentType} subfilter={false}/>
                  <ListFilter labelText='Cible - Catégorie' choices={categories.sort((a, b) => (a.name > b.name)?1:-1)} choiceParam={'name'} selectedItem={selectedCat} setSelectedItem={setSelectedCat} subfilter={false}/>
                  <ListFilter labelText='Cible - Variété' choices={filteredVarieties.sort((a, b) => (a.name > b.name)?1:-1)} choiceParam={'name'} selectedItem={selectedVar} setSelectedItem={setSelectedVar} subfilter={true}/>
                  <ListFilter labelText='Cible - Type de cible' choices={targetTypes.sort((a, b) => (a.name > b.name)?1:-1)} choiceParam={'name'} selectedItem={selectedTargetType} setSelectedItem={setSelectedTargetType} subfilter={false}/>
                  {/*Le filtre pour 'Article scientifique' est fait directement sans composant car le texte affiché a besoin d'être personalisé*/}
                  <label className={'list-filter'}>
                    <p className='list-filter-label'>{'Article scientifique'} :</p>
                    <select name='selectedChoice' className='list-filter-option' value={selectedArticle} onChange={e => setSelectedArticle(e.target.value)}>
                      <option value={0}>{'--Tous--'}</option>
                      {articles.sort((a, b) => (a.author > b.author)?1:-1).map((choice) =>
                        <option key={choice['id']} value={choice['id']}>{choice['author']}{choice['published_year']}-{choice['title']}</option>
                      )}
                    </select>
                  </label>
                  <ListFilter labelText='Rapports internes' choices={reports.sort((a, b) => (a.internal_reference > b.internal_reference)?1:-1)} choiceParam={'internal_reference'} selectedItem={selectedReport} setSelectedItem={setSelectedReport} subfilter={false}/>
                  <ListFilter labelText='Année' choices={years.sort((a, b) => (a.value > b.value)?1:-1)} choiceParam={'value'} selectedItem={selectedYear} setSelectedItem={setSelectedYear} subfilter={false}/>
                  <ListFilter labelText='Status de validation' choices={validationStatus} choiceParam={'name'} selectedItem={selectedValidationStatus} setSelectedItem={setSelectedValidationStatus} subfilter={false}/>
                  <div>
                    <button onClick={filterReset} className='button-secondary clickable'>Sans filtres</button>
                  </div>
                </div>
                {(screenWidth > 650) ? null : <Divider/>}
                {/*Trials list*/}
                <div className='scroll-list-rd'>
                  <h2 className='subtitle'>Nombre d'essais : {filteredTrials.length}</h2>
                  {/*Display trials list*/}
                  {(filteredTrials && filteredTrials.length !== 0) ? (
                    filteredTrials.sort((a, b) => 
                      (a.year !== b.year) ? (a.year - b.year) : 
                      (a.month_id !== b.month_id) ? (a.month_id - b.month_id) : 
                      a.reference.localeCompare(b.reference)).map((trial) => (
                      <ItemLink key={trial['id']} id={trial['id']} path={"/trials/"} onClick={saveFilters}>
                        <div className='grid-10-1'>
                          <h3 className='item-text'>{trial['name']}</h3> 
                          <div className='flex-row justify-end'>
                            <div/>
                            <IconStatus color={trial["validation_status"]["color"]}></IconStatus>
                          </div>
                        </div>
                      </ItemLink>
                    ))
                  ) : (
                    <p>Aucun essai actuellement. Veuillez en créer un !</p>
                  )}
                </div>
              </div>
            ) : (
              <h1>Connexion failed</h1>
            )
          )}
        </Container>
      </div>
    </div>
  );
}

export default TrialList;
